import { render, staticRenderFns } from "./secondarydepartment.vue?vue&type=template&id=5707b617&scoped=true"
import script from "./secondarydepartment.vue?vue&type=script&lang=js"
export * from "./secondarydepartment.vue?vue&type=script&lang=js"
import style0 from "./secondarydepartment.vue?vue&type=style&index=0&id=5707b617&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707b617",
  null
  
)

export default component.exports